let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("b4NO6"), load("fM2oh"), load("3fLE9"), load("guNAg"), load("b37xN"), load("ik6u5")]).then(() => parcelRequire('1a3n4'));